import { useApiQuery } from '@/hooks/useApiQuery';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiGet, apiPost, operationsClient } from '@/lib/api';
import { tuneUpEndpoints } from '@/lib/api/endpoints';

/** NOT-598 — per-tenant settings for the proactive tune-up outreach engine
 * (now event-driven). The office queue itself lives on Recurring Service Events;
 * only these engine settings remain a standalone surface. */
export interface TuneUpSettings {
  autoScheduleEnabled: boolean;
  leadDays: number;
  loadSmoothing: 'ON' | 'NEXT_AVAILABLE';
  intervalsHours: number[];
  maxAttempts: number;
  jobTypeId: string | null;
  durationMinutes: number;
}

export function useTuneUpSettings() {
  return useApiQuery<TuneUpSettings>({
    queryKey: ['tune-up-settings'],
    queryFn: () => apiGet<TuneUpSettings>(operationsClient, tuneUpEndpoints.settings()),
    showErrorToast: false,
  });
}

export function useUpdateTuneUpSettings() {
  return useApiMutation<TuneUpSettings, Partial<TuneUpSettings>>({
    mutationFn: (patch) => apiPost(operationsClient, tuneUpEndpoints.settings(), patch),
  });
}
